import { render, staticRenderFns } from "./uploadNewMusic.vue?vue&type=template&id=0af9ea8c&scoped=true&"
import script from "./uploadNewMusic.vue?vue&type=script&lang=js&"
export * from "./uploadNewMusic.vue?vue&type=script&lang=js&"
import style0 from "./uploadNewMusic.vue?vue&type=style&index=0&id=0af9ea8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af9ea8c",
  null
  
)

export default component.exports